.banner {
  aspect-ratio: 16/9;
  background-color: rgb(100 100 100);
  position: relative;
  width: 100%;
}

.image {
  background-position: center;
  background-size: cover;
  height: 100%;
  position: absolute;
  width: 100%;
}

.infos {
  margin: var(--space-medium);
}

.infos>div:nth-child(2) {
  margin-top: var(--space-small);
}

.gold {
  color: var(--theme-trophy-gold) !important;
}

.iron {
  color: var(--theme-trophy-iron) !important;
}

.bronze {
  color: var(--theme-trophy-bronze) !important;
}

.warning {
  color: var(--theme-trophy-gold) !important;
}

.boostedBorder {
  border: 2px solid var(--theme-medium-purple);
  border-radius: var(--border-radius-medium);
  box-sizing: border-box;
  height: 100%;
  left: 0;
  pointer-events: none;
  position: absolute;
  top: 0;
  width: 100%;
}